import React, {Component} from "react";
import {DatePicker, Row, Select} from "antd";
import {connect} from "react-redux";
import cookie from "react-cookies";
import {
    changeOrdering,
    clearAllFilters,
    getAll,
    getReadCases,
    getUnreadCases,
    setDateRange
} from "../../redux_actions/search.case.action";
import moment from 'moment';
import {updateSort} from "../../redux_actions/morpheus.setting.action";
import {Stack} from "@mui/material";
import {caseReadStatusEnum as CaseReadcaseReadStatusEnum, caseReadStatusEnum} from "../../utils/const";

const { RangePicker } = DatePicker
const Option = Select.Option;
var today = new Date();
var dd = today.getDate();

class FilterCompClia extends Component {
    constructor(props) {
        super(props);
        this.handleTypeChange = this.handleTypeChange.bind(this);
        this.handleClear = this.handleClear.bind(this);
        this.handleDateRangeChange = this.handleDateRangeChange.bind(this);
    }

    handleTypeChange(value) {
        if (value === CaseReadcaseReadStatusEnum.UNREAD) {
            this.props.dispatch(getUnreadCases(this.props.urlState));
        } else if (value === CaseReadcaseReadStatusEnum.READ) {
            this.props.dispatch(getReadCases(this.props.urlState));
        } else if (value === CaseReadcaseReadStatusEnum.ALL) {
            this.props.dispatch(getAll(this.props.urlState));
        }
    }

    handleDateRangeChange(moment) {
        try {
            this.props.dispatch(setDateRange(moment[0].format("YYYY-MM-DD"), moment[1].format("YYYY-MM-DD"), this.props.urlState));
        } catch (err) {
            this.props.dispatch(setDateRange('', '', this.props.urlState));
        }
    }

    handleSortChange = (value) => {
        this.props.dispatch(changeOrdering(value, this.props.urlState));
        this.props.dispatch(updateSort({case_order_by: value}));
    }

    handleClear() {
        this.props.dispatch(clearAllFilters());
    }

    render() {
        var isMobile = cookie.loadAll().isMobile === "true";
        return (
            this.props.isFetching === true ?
                <Row >
                </Row>
                :
                <Stack style={isMobile ? {height:"6em"} : {}} direction={"row-reverse"} alignItems={"center"} spacing={1}>
                    <Select
                        value={this.props.urlState.read_status}
                        placeholder="Select Type"
                        onChange={this.handleTypeChange}
                        style={{width:180, marginLeft:8}}
                    >
                        <Option value={CaseReadcaseReadStatusEnum.UNREAD}>Unread</Option>
                        <Option value={CaseReadcaseReadStatusEnum.READ}>Read</Option>
                        <Option value={CaseReadcaseReadStatusEnum.ALL}>All</Option>
                    </Select>
                    <RangePicker
                        dateRender={current => {
                            const style = {};
                            if (current.date() === dd) {
                                style.backgroundColor = "transparent";
                                style.color = "black";
                            }
                            return (
                                <div className="ant-calendar-date" style={style}>
                                    {current.date()}
                                </div>
                            );
                        }}
                        showToday
                        onChange={this.handleDateRangeChange}
                        value={(this.props.urlState.date__lte === undefined || this.props.urlState.date__lte.length === 0) ?
                            undefined : [moment(this.props.urlState.date__gte, "YYYY-MM-DD"), moment(this.props.urlState.date__lte, "YYYY-MM-DD")]}
                        format="YYYY-MM-DD"
                        defaultValue={[undefined, undefined]}
                    />
                    <Select
                        value={this.props.urlState.ordering}
                        placeholder="Sort List"
                        onChange={this.handleSortChange}
                        style={{width:130}}
                    >
                        <Option value="-case_id">
                            Folder Name
                        </Option>
                        <Option value="priority">
                            Priority
                        </Option>
                        <Option value="date">
                            Oldest First
                        </Option>
                        <Option value="-date">
                            Recent First
                        </Option>
                        <Option value={"case_status__status"}>
                            Status
                        </Option>
                    </Select>
                </Stack>
        );
    }
}

const mapStateToProps = state => {
    return {
        isFetching: state.searchCaseReducer.isFetching,
        loginStatus: state.loginAlerts.loginStatus,
        urlState: state.searchCaseReducer,
        morpheusSetting: state.morpheusSettingReducer
    };
};

export default connect(mapStateToProps)(FilterCompClia);
